/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * Common Component. Its used in product-offering(PDP) and product Selector page
 */
/** */
/* tslint:disable: no-loop-func max-file-line-count*/
/*tslint:disable:max-file-line-count */
// Core
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  EventEmitter,
  Output,
  Renderer2,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { SelectItem } from 'primeng/api';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
// Interfaces
import { ProductDetails } from 'app/experience/shop/product-details/interfaces/product-details.interface';
import {
  ItemDetail,
  Promotion,
  ColorOption,
  MemoryOption,
  DeviceSimInfo,
} from 'app/support/api/common/product.interface';
import { ConfigData } from 'app/experience/repdash/interfaces/aem-content.interface';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { PricingOptions } from '@support/api/common/product.interface';
import { CartItem } from '@support/api/proxies/responses/api-cart-response.interface';
// Environment settings
import { SETTINGS } from '@environment/settings';
// Services
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
// Constants
import {
  DATE_FORMAT,
  HARDGOODS_CONSTANTS,
  AVAILABILITY,
  DIGITALDATA_CONSTANT,
} from '@experience/shop/hardgoods/constants/browse-hardgoods.constants';
import { ConditionalEnhancement } from '@experience/shop/hardgoods/interfaces/browse-hardgood.interface';
import { PRODUCT_OFFERINGS_CONSTANTS } from '@core/aem/components/product-offerings/product-offerings.constants';
import { TEXT_CONSTANTS } from '@support/shared/constants/device.constants';
import { Subject } from 'rxjs';
import moment from 'moment';
import { PRODUCT_DETAILS_CONST } from '@experience/shop/product-details/product-details.constants';
import { ProductDetailsService } from '@experience/shop/services/product-details.service';
import { ReviewsQuery } from '@experience/shop/product-details/models/review-query.model';
import { takeUntil } from 'rxjs/operators';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { UserService } from '@support/shared/services/user.service';
import { AppConfig } from '@root/app.config';

@Component({
  selector: 'tmo-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['../../../../../style-sheets/components/input-radio.component.scss'],
})
export class DeviceDetailsComponent implements OnInit, OnDestroy {
  /**
   * Stores selected device details
   */
  @Input() public deviceDetails: ProductDetails;
  /**
   * Stores value of saved amount
   */
  public savedAmountText: string;
  /**
   * Device without qualifying plan content
   */
  public withoutQualifyingPlan: string;
  /**
   * Device only at price text
   */
  public deviceOnly: string;
  /**
   * Device without qualifying plan content
   */
  public requirementForDevicePricing: string;
  /**
   * Device estimated Shipping From Date Time
   */
  public estimatedShippingText: string;
  /**
   * Device estimated Shipping From Date Time
   */
  public hasEstimatedShippingDate: boolean;
  /**
   * Device availability Status
   */
  public availabilityStatus: string;
  /** Varibale to track max images to display */
  public carousalLength: number;
  /**
   * Holds banner text
   */
  public bannerText: string;
  /**
   * Holds true if i don't need a plan is selected
   */
  @Input() public noNeedPlan: boolean;
  /**
   * Stores selected specific details. Ex: color, URL etc..,
   */
  @Input() public set selectedItem(device: ItemDetail) {
    if (device) {
      this.selectedDevice = device;
      this.formatAemContent();
      this.productDetailsService.getselectedDeviceId$.emit(this.selectedDevice);
      this.mainImageUrl = this.objectService.get(this.selectedDevice, 'mainImageUrl')
        ? this.extTmoImagesUrl.concat(this.objectService.get(this.selectedDevice, 'mainImageUrl'))
        : this.dummyImage;
      if (Array.isArray(device.deviceSimInfo)) {
        this.deviceSimInfo = device.deviceSimInfo;
      }
      this.setDefaultSimInfo();
      this.discountAmount();
      this.splitPrice();
      this.bannerText = this.objectService.get(this.selectedDevice, 'bannerText');
      this.setEnhancement('bannerText', 'bannerText', this.selectedDevice);
    }
  }

  /**
   * Stores the selected plan's price
   */
  @Input() public selectedPlanPrice: number;

  /**
   * Holds selected Devicedetails
   */
  public selectedDevice: ItemDetail;

  /**
   * Holds main image URL
   */
  public mainImageUrl: string;
  /**
   * Stores value of whether assisted or unassisted flow
   */
  @Input() public isAssistedFlow: boolean;
  /**
   * Holds static content data
   */
  @Input() public pdpStaticContent: ConfigData;
  /**
   * Holds value of promotions
   */
  @Input() public promotions: Promotion[];
  /**
   * Holds value of color options
   */
  @Input() public colorOptions: ColorOption[];
  /**
   * Holds value of cache image paths
   */
  @Input() public cacheImages: string[];
  /**
   * Holds value of memory options
   */
  @Input() public memoryOptions: MemoryOption[];
  /**
   * Flag to hold if it is product selector
   */
  @Input() public isProductSelector: boolean;
  /**
   * Holds value of existing line
   */
  @Input() public isExistingLine: boolean;
  /**
   * Holds value of epin
   */
  @Input() public isEpin: boolean;
  /**
   * Holds amount selected in dropdown
   */
  @Input() public selectedEipAmount: string;
  /**
   * Holds all available amount to display in dropdown
   */
  @Input() public set pricingOptions(pricing: PricingOptions[]) {
    this.epinPriceDetails = pricing;
  }

  /**
   * Holds boolean and sets to true if product subtype is simcard
   */
  @Input() public isSimCard: boolean;
  /**
   * Emits color selection shange value
   */
  @Output() public colorSelectionChange: EventEmitter<string>;
  /**
   * Emits availability status
   */
  @Output() public isAvailable: EventEmitter<boolean>;
  /**
   * Emits memory selection shange value
   */
  @Output() public memorySelectionChange: EventEmitter<string>;

  /**
   * Emits SIM Type selection change value
   */
  @Output() public simInfoSelectionChange: EventEmitter<DeviceSimInfo>;

  /**
   * Emits certified pre owned device
   */
  @Output() public certifiedDevice: EventEmitter<boolean>;

  /**
   * Emits quantity update
   */
  @Output() public quantityChanged: EventEmitter<number>;
  /**
   * Holds the dummy image url
   */
  public dummyImage: string;
  /**
   * Flag to see open or close modal
   */
  public showPromoModal: boolean;
  /**
   * Holds the external domain URL to load images
   */
  public extTmoImagesUrl: string;
  /**
   * Modal related to close accounts
   */
  public modal: DynamicModal;
  /**
   * Stores the selected item memory
   */
  public memory: string;

  /**
   * Stores current selected SIM info
   */
  public simInfo: DeviceSimInfo;

  /**
   * Contains array of DeviceSimInfo for current device
   */
  public deviceSimInfo: DeviceSimInfo[];
  /**
   * Stores the value of list price whole Number
   */
  public listPriceWholeNumber: string;
  /**
   * Stores the value of list price decimal Number
   */
  public listPriceDecimalNumber: string;
  /**
   * Stores the value of short description
   */
  public shortDescription: string;
  /**
   * Stores value of promo description
   */
  public promoDescription: Promotion;
  /**
   * Stores the value of long description
   */
  public longDescription: string;
  /**
   * Event Emitter to trigger events on click of anchor
   */
  public triggerEvent: EventEmitter<Object>;
  /**
   * Stores the value of price without service
   */
  public withoutServicePriceText: string;
  /**
   * priceDisclaimer text
   */
  public priceDisclaimer: string;
  /**
   * to store the max quantity in cart
   */
  public maxQtyAllowed: number;
  /**
   * Stores the Quantity drop down options
   */
  public qtyList: SelectItem[];
  /**
   * count of the accessories already added to cart
   */
  public existingAccessoryCount: number;
  /**
   * Quantity of items selected
   */
  public selectedQuantity: number;
  /**
   * to store the form for accessory
   */
  public accessoriesOfferingsFormGroup: UntypedFormGroup;
  /**
   * to store the form for accessory
   */
  public noOfReviewsText: string;
  /**
   * Stores the pricing options for Epin
   */
  public epinPriceDetails: PricingOptions[];
  /**
   * Variable to store lowerPrice message
   */
  public lowerPriceMessage: string;
  /**
   * Take Until.
   */
  private ngUnsubscribe: Subject<void>;
  /**
   * boolean to keep check if user is in upgrade flow
   */
  @Input() public isUpgrade: boolean;
  /**
   * Variable to check accessory
   */
  public accessoryConstant: string;
  public isEsimEnabled: boolean;
  /**
   * Boolean value to check for the assisted
   */
  // public isAssisted: boolean;
  /**
   * Variable to check if channel is web
   */
  // public isWebChannel: boolean;
  /**
   * variable to show updated browse plan
   */
  // public showUpdatedBrowseDevices: boolean;
  /**
   * variable to store query parameters for fetching device reviews
   */
  public queryParams: ReviewsQuery;
  /**
   * variable to HOLD p10m flag
   */
  public isP10MCustomer: boolean;
  /**
   * Boolean varible to hold feature flag value
   */
  public esimActivationsEnabled: boolean;
  public isShowEsim: Boolean = true; // Show Esim

  public isAuthenticated: boolean;

  constructor(
    private objectService: ObjectService,
    private currencyPipe: CurrencyPipe,
    private productDetailsService: ProductDetailsService,
    private stateStoreUtilsService: StateStoreUtilsService,
    private commonUtilService: CommonUtilService,
    public featureToggleUtilService: FeatureToggleUtilService,
    private formBuilder: UntypedFormBuilder,
    private renderer: Renderer2,
    private cartSupportService: CartSupportService,
    private userService: UserService,
    private appConfig: AppConfig
  ) {
    this.extTmoImagesUrl = SETTINGS.EXT_IMAGE_URL;
    this.showPromoModal = false;
    this.modal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'promotions-modal',
    };
    this.colorSelectionChange = new EventEmitter<string>();
    this.memorySelectionChange = new EventEmitter<string>();
    this.simInfoSelectionChange = new EventEmitter<DeviceSimInfo>();
    this.certifiedDevice = new EventEmitter<boolean>();
    this.quantityChanged = new EventEmitter<number>();
    this.ngUnsubscribe = new Subject<void>();
    this.isAvailable = new EventEmitter<boolean>();
    this.accessoryConstant = HARDGOODS_CONSTANTS.ACCESSORY;
    this.carousalLength = TEXT_CONSTANTS.CAROUSAL_SIZE;
    this.esimActivationsEnabled = this.featureToggleUtilService.isEsimActivationsEnabled();
    this.isAuthenticated = !!this.stateStoreUtilsService.getAuthCustomerId();
  }

  public updateImagePath(imageUrl: string): void {
    this.mainImageUrl = imageUrl;
  }
  /**
   * Loads the initial configuration of Product Selector Page
   * @returns void
   */
  public ngOnInit(): void {
    this.noNeedPlan = this.objectService.get(
      this.stateStoreUtilsService.getFocusedTileLineNonLineItem(),
      'noPlanNeeded',
      false
    );
    // this.isAssisted = (SETTINGS.CHANNEL.toLowerCase() !== CHANNELS.WEB);
    // this.isWebChannel = SETTINGS.CHANNEL.toLowerCase() === CHANNELS.WEB;
    // this.showUpdatedBrowseDevices = (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL);
    this.isEsimEnabled = this.stateStoreUtilsService.getEsimToggleEnabled();
    if (this.cacheImages && this.cacheImages.length) {
      this.cacheImages.forEach((image: string) => {
        const img = this.renderer.createElement('img');
        this.renderer.setAttribute(img, 'src', this.extTmoImagesUrl.concat(image));
      });
    }
    this.selectedQuantity =
      this.stateStoreUtilsService.getCartId() &&
      this.stateStoreUtilsService.getCartId() !== 'CARTID'
        ? this.stateStoreUtilsService.getQuantity(this.objectService.get(this.selectedDevice, `id`))
        : PRODUCT_OFFERINGS_CONSTANTS.ONE;
    this.getDummyImageUrl();
    this.splitPrice();
    if (this.objectService.get(this.selectedDevice, 'memory')) {
      this.memory =
        this.selectedDevice.memory.indexOf(' ') > -1
          ? this.selectedDevice.memory.split(' ')[0]
          : this.selectedDevice.memory;
    }
    this.discountAmount();
    this.formatAemContent();
    if (this.checkIfDropdownNeeded()) {
      this.maxQtyAllowed = this.isEpin
        ? PRODUCT_OFFERINGS_CONSTANTS.MAX_EPIN_QTY
        : PRODUCT_OFFERINGS_CONSTANTS.MAX_QTY;
      if (this.isEpin) {
        this.getTotalEPinInCart();
      }
      this.createQtyDropdown();
      this.existingAccessoryCount = PRODUCT_OFFERINGS_CONSTANTS.MAX_QTY;
      this.accessoriesOfferingsFormGroup = this.formBuilder.group({
        qty: [],
        pricingOption: [],
      });
    }
    this.cartSupportService.cartUpdated$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: boolean) => {
        if (this.selectedPlanPrice) {
          this.lowerPriceMessage = this.commonUtilService.messageFormatter(
            this.objectService.get(this.pdpStaticContent, 'lowerPriceMessage'),
            [
              this.currencyPipe.transform(
                this.objectService.get(this.selectedDevice, 'serviceThreshold'),
                'USD',
                'symbol-narrow',
                '1.2-2'
              ),
            ]
          );
        }
        if (this.isEpin) {
          this.getTotalEPinInCart();
          this.createQtyDropdown();
        }
      });
    this.cartSupportService.planSelected$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((value: string) => {
        this.lowerPriceMessage = this.commonUtilService.messageFormatter(
          this.objectService.get(this.pdpStaticContent, 'lowerPriceMessage'),
          [
            this.currencyPipe.transform(
              this.objectService.get(this.selectedDevice, 'serviceThreshold'),
              'USD',
              'symbol-narrow',
              '1.2-2'
            ),
          ]
        );
      });

    this.userService.p10CustomerLoggedIn$
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: boolean) => {
        this.isP10MCustomer = data;
      });
  }

  /**
   * To check if enhancement property is to be set based on conditions for enhancement
   * @param property
   * @param enhancementProperty
   * @param selectedItem
   */
  private setEnhancement(
    property: string,
    enhancementProperty: string,
    selectedItem: ItemDetail
  ): void {
    if (!this[property]) {
      const brand: string = this.stateStoreUtilsService.getBrand();
      const enhancement: ConditionalEnhancement = this.objectService.get(
        this.appConfig.getConfig('devicesPromos') || {},
        `${selectedItem.id}.${brand}`
      );
      if (enhancement) {
        if (
          (this.isAuthenticated && enhancement.showAuth) ||
          (!this.isAuthenticated && enhancement.showUnauth)
        ) {
          this[property] = enhancement[enhancementProperty];
        }
      }
    }
  }

  /**
   * method to determine if dropdown should be created
   * @return boolean
   */
  private checkIfDropdownNeeded(): boolean {
    return (
      (this.deviceDetails.type || '').toLocaleLowerCase() ===
        PRODUCT_OFFERINGS_CONSTANTS.ACCESSORY.toLocaleLowerCase() ||
      this.isEpin ||
      this.isSimCard
    );
  }

  /**
   * method to calculate discounted amount for the selected device
   * @return void
   */
  private discountAmount(): void {
    if (this.objectService.get(this.selectedDevice, 'hasSale')) {
      const discount = this.currencyPipe.transform(
        this.selectedDevice.listPrice - this.selectedDevice.salePrice,
        'USD',
        'symbol-narrow',
        '1.2-2'
      );
      this.savedAmountText = this.commonUtilService.messageFormatter(
        this.objectService.get(this.pdpStaticContent, 'savedAmount'),
        [discount]
      );
    }
  }

  /**
   * update the selected color of device
   * @param color passes the selected color
   * @returns void
   */
  public updateSelectedColor(color: string): void {
    this.formatAemContent();
    this.colorSelectionChange.emit(color);
  }

  /**
   * update the selected memory of device
   * @param memory passes the selected memory
   * @returns void
   */
  public updateSelectedMemory(memory: string): void {
    this.formatAemContent();
    this.memorySelectionChange.emit(memory);
  }

  /**
   * Update the selected SIM Info of device
   * @param simInfo passes the selected SIM Info
   */
  public updateSelectedSimInfo(simInfo: DeviceSimInfo): void {
    this.formatAemContent();
    this.simInfo = simInfo;
    this.simInfoSelectionChange.emit(simInfo);
    if (this.isEsimEnabled) {
      this.isShowEsim = simInfo && simInfo.simType.toLowerCase() === 'esim' ? true : false;
    } else {
      this.isShowEsim = simInfo ? simInfo.isDefault : false;
    }
  }

  /**
   * Destroys all the subscriptions
   * @returns {void}
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Function to split amount
   */
  public splitPrice(): void {
    const numberOfDecimalDigits = 2;
    const listAmount = this.objectService.get(this.selectedDevice, 'listPrice');
    if (listAmount) {
      const tempNumber = listAmount.toFixed(numberOfDecimalDigits);
      this.listPriceWholeNumber = tempNumber.split('.')[0];
      this.listPriceDecimalNumber = tempNumber.split('.')[1];
    } else {
      this.listPriceWholeNumber = this.listPriceDecimalNumber = '00';
    }
  }

  /**
   * Function used to get no image found image
   */
  public getDummyImageUrl(): void {
    this.dummyImage = this.commonUtilService.getImageUrl(null);
  }

  /**
   * Method to handle Click event
   * @returns void
   */
  public closeModal(): void {
    this.modal.toggleModalEmitter.emit({
      open: false,
      close: true,
    });
    this.showPromoModal = false;
  }

  /**
   * Showing of modal on toggle event
   * @param event : toggle event
   * @returns void
   */
  public showPromotionalModal(index?: number): void {
    this.promoDescription = this.selectedDevice.itemPromotions[index];
    this.showPromoModal = true;
    this.modal.toggleModalEmitter.emit({ open: true, close: false });
  }

  /**
   * Emit outPut Event for CPO
   * @param event : hasCPO event
   * @returns void
   */
  public getCertifiedPreOwnDevice(hasCPO: boolean): void {
    if (
      this.selectedDevice.condition === 'New'
        ? this.selectedDevice.hasCPO
        : this.selectedDevice.hasNew
    ) {
      this.certifiedDevice.emit(hasCPO);
    }
  }

  /**
   * set quantity dropdown list as per Epins in Cart
   * @param cart : Cart
   * @returns void
   */
  private getTotalEPinInCart(): void {
    const cart = this.stateStoreUtilsService.getCart();
    if (cart) {
      const epinsInCart = cart.accessories.filter((accessory: CartItem) => {
        const productSubType = this.objectService.get(accessory, 'productSubType.0');
        const productSubTypeInUpperCase = productSubType ? productSubType.toUpperCase() : '';
        return productSubTypeInUpperCase === HARDGOODS_CONSTANTS.VOUCHER;
      }).length;
      const updatedEpinQuantity = PRODUCT_OFFERINGS_CONSTANTS.MAX_EPIN_QTY - epinsInCart;
      this.maxQtyAllowed =
        updatedEpinQuantity > 0 ? updatedEpinQuantity : PRODUCT_OFFERINGS_CONSTANTS.ONE;
    }
  }

  /*
   * Updates selected accessory quantity
   * @returns void
   */
  public onUpdateQty(): void {
    const defaultQuantity = 1;
    const selectedQty = this.selectedQuantity || defaultQuantity;
    const productInfo = this.objectService.get(
      window,
      `${DIGITALDATA_CONSTANT.DIGITALDATA}.${DIGITALDATA_CONSTANT.PRODUCT}.0.${DIGITALDATA_CONSTANT.PRODUCTINFO}`
    );
    // if (this.isWebChannel && productInfo) {
    if (productInfo) {
      productInfo[DIGITALDATA_CONSTANT.QTY] = selectedQty;
    }
    this.stateStoreUtilsService.setQuantity(
      selectedQty,
      this.objectService.get(this.selectedDevice, `id`)
    );
    this.quantityChanged.emit(this.selectedQuantity || defaultQuantity);
  }

  /**
   * Method to format the AEM content
   * @returns void
   */
  private formatAemContent(): void {
    let estimatedShippingFromDateTime = this.objectService.get(
      this.selectedDevice,
      `estimatedShippingFromDateTime`
    );
    let estimatedShippingToDateTime = this.objectService.get(
      this.selectedDevice,
      `estimatedShippingToDateTime`
    );

    this.hasEstimatedShippingDate = !!(
      estimatedShippingFromDateTime && estimatedShippingToDateTime
    );

    if (this.hasEstimatedShippingDate) {
      estimatedShippingFromDateTime = moment(estimatedShippingFromDateTime).format(
        DATE_FORMAT.MMDDYYYY
      );
      estimatedShippingToDateTime = moment(estimatedShippingToDateTime).format(
        DATE_FORMAT.MMDDYYYY
      );

      this.estimatedShippingText = this.commonUtilService.messageFormatter(
        this.objectService.get(this.pdpStaticContent, 'expectedToShipDate'),
        [estimatedShippingFromDateTime, estimatedShippingToDateTime]
      );
    }
    this.getAvailabilityStatus();
    const priceWithoutService = this.currencyPipe.transform(
      this.objectService.get(this.selectedDevice, 'priceWithoutService'),
      'USD',
      'symbol-narrow',
      '1.2-2'
    );
    const serviceThresholdPrice = this.currencyPipe.transform(
      this.objectService.get(this.selectedDevice, 'serviceThreshold'),
      'USD',
      'symbol-narrow',
      '1.2-2'
    );
    this.withoutServicePriceText = this.commonUtilService.messageFormatter(
      this.objectService.get(this.pdpStaticContent, 'withoutServicePriceDisclaimer'),
      [
        priceWithoutService || HARDGOODS_CONSTANTS.DEFAULT_AMOUNT,
        serviceThresholdPrice || HARDGOODS_CONSTANTS.DEFAULT_AMOUNT,
      ]
    );
    this.priceDisclaimer = this.commonUtilService.messageFormatter(
      this.objectService.get(this.pdpStaticContent, 'priceDisclaimer'),
      [HARDGOODS_CONSTANTS.SIMSTARTKIT]
    );
    this.deviceOnly = this.commonUtilService.messageFormatter(
      this.objectService.get(this.pdpStaticContent, 'deviceOnly'),
      [priceWithoutService]
    );
    this.requirementForDevicePricing = this.commonUtilService.messageFormatter(
      this.objectService.get(this.pdpStaticContent, 'requirementForDevicePricing'),
      [serviceThresholdPrice]
    );
    // E2E Fix: DE21812938 - Get Reviews from bazaar voice instead of elastic search
    if (!this.queryParams) {
      this.queryParams = new ReviewsQuery(PRODUCT_DETAILS_CONST.LANDING);
      this.queryParams.setLimit(PRODUCT_DETAILS_CONST.REVIEW_PDP_LIMIT);
    } else {
      this.queryParams = new ReviewsQuery(PRODUCT_DETAILS_CONST.DETAILS);
      this.queryParams.setLimit(PRODUCT_DETAILS_CONST.REVIEW_ALL_LIMIT);
    }
    const offerId = this.stateStoreUtilsService.getSelectedOfferId();
  }
  /**
   * creates a form for quantity dropdown and assigns a default selected quantity
   * @returns void
   */
  private createQtyDropdown(): void {
    this.qtyList = [];
    for (let key = 1; key <= this.maxQtyAllowed; key++) {
      const dropdownData = { label: key.toString(), value: key };
      this.qtyList.push(dropdownData);
    }
    const selectedQty: string = this.existingAccessoryCount
      ? this.existingAccessoryCount
      : this.qtyList[0].value;
    this.accessoriesOfferingsFormGroup = this.formBuilder.group({
      qty: [selectedQty],
    });
    this.onUpdateQty();
  }

  /**
   * Function used to remove white space
   * @param {string} name
   * @returns {string}
   */
  public getColorName(name: string = ''): string {
    return name.replace(/\s/g, '').toLowerCase();
  }

  /**
   * Function to get availability status
   * @returns void
   */
  private getAvailabilityStatus(): void {
    let isAvailable = true;
    this.availabilityStatus = this.objectService.get(this.selectedDevice, `availabilityStatus`);
    switch (this.availabilityStatus) {
      case AVAILABILITY.IN_STOCK:
        this.availabilityStatus = this.objectService.get(this.pdpStaticContent, 'inStock');
        break;
      case AVAILABILITY.LIMITEDAVAILABILITY:
        this.availabilityStatus = this.objectService.get(
          this.pdpStaticContent,
          'limitedAvailability'
        );
        break;
      case AVAILABILITY.BACKORDERED:
        this.availabilityStatus = this.objectService.get(this.pdpStaticContent, 'backordered');
        break;
      case AVAILABILITY.OUT_OF_STOCK:
        this.availabilityStatus = this.objectService.get(this.pdpStaticContent, 'outOfStock');
        isAvailable = false;
        break;
      default:
        this.availabilityStatus = this.objectService.get(this.selectedDevice, `availabilityStatus`);
    }
    this.isAvailable.emit(isAvailable);
  }

  /**
   * Set default SimInfo for device based on isDefault attribute
   */
  private setDefaultSimInfo(): void {
    if (this.deviceSimInfo && this.deviceSimInfo.length > 0) {
      const existingSimSelection = this.stateStoreUtilsService.getSelectedSimInfo();
      this.selectedDevice.simInfo = this.deviceSimInfo.find(
        (sim: DeviceSimInfo) => sim.isDefault === true
      );
      this.updateSelectedSimInfo(this.selectedDevice.simInfo);
    } else {
      this.updateSelectedSimInfo(null);
    }
  }
}
